<script setup lang="ts">
const { $isAndroid, $isIOS } = useNuxtApp()
const isAndroid = $isAndroid()
const isIOS = $isIOS()
const screen = useScreen()

const route = useRoute()
const router = useRouter()
const { scrollY } = useScrollState()

const url = route.path.split('?')[0]?.substring(1) || ''

function openWap() {
  // current is www.mfuns.net/xxxxx, wap is m.mfuns.net/xxxxx
  window.location.href = `https://m.mfuns.net${route.path}`
}

function downloadApp() {
  router.push('/download')
}
</script>

<template>
  <div
    v-if="(screen.xs || screen.sm) && (isAndroid || isIOS)"
    class="m-open-app"
    :style="{
      bottom: `-${scrollY}px`
    }"
  >
    <n-button
      v-if="isAndroid"
      type="primary"
      class="m-open-app-btn app"
      @click="openApp(url)"
    >
      在APP中打开
      <n-icon v-if="isAndroid" class="bi bi-android" />
      <n-icon v-if="isIOS" class="bi bi-apple" />
    </n-button>
    <n-button
      secondary
      type="primary"
      class="m-open-app-btn download"
      @click="downloadApp"
    >
      下载App浏览更多内容
    </n-button>
    <n-button
      secondary
      type="primary"
      class="m-open-app-btn wap"
      @click="openWap"
    >
      打开WAP(手机版网页)版
    </n-button>
  </div>
</template>

<style lang="scss" scoped>
.m-open-app {
  position: fixed;
  left: 0;
  right: 0;
  width: fit-content;
  margin: auto;
  z-index: 1000;
  text-align: center;
  display: flex;
  flex-direction: column;
  &-btn {
    border-radius: 18px;
    height: 36px;
    width: 200px;
    line-height: 36px;
    margin-bottom: 12px;
    color: #fff;
    padding: 0 12px;
    box-shadow: var(--shadow-md);
  }
  .download {
    background-color: var(--color-sky-600);
    color: #fff;
  }
  .wap {
    background-color: var(--color-indigo-100);
    color: #000;
  }
}
</style>
